/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/forbid-prop-types */
import React from "react";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import EditTabTriggerEmail from "./EditTabTriggerEmail";
import PreviewTabTriggerEmail from "./PreviewTabTriggerEmail";
import Kebabs from "../../assets/img/icons/icon-kebabs-black.svg";
import ConfirmDialog from "./ConfirmDialog";
import communicationSmartFields from "../../utils/smartFields";
import { format } from "../../utils/flatten";
import * as communicationActions from "../../redux/actions/communicationActions";

const mapDispatchToProps = {
  ...communicationActions,
};

const mapStateToProps = (state) => {
  const { workflows } = state;

  return {
    stateWorkflow: workflows,
  };
};

function EditTriggerEmail({
  show,
  event,
  stateWorkflow,
  resetDefault,
  hidePanelClick,
  saveWorkflow,
  canSaveWorkflow,
  deleteWorkflowStep,
}) {
  React.useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "unset");
  }, []);

  const [showContext, setShowContext] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(true);

  const onPreviewClick = React.useCallback(() => setShowEdit(false), []);
  const onEditClick = React.useCallback(() => setShowEdit(true), []);
  const onKebabClick = React.useCallback(
    () => setShowContext(!showContext),
    [setShowContext, showContext],
  );
  const hideMenu = React.useCallback(() => setShowContext(false), []);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);

  const [headerContent, setHeaderContent] = React.useState("Delete Email");
  const [bodyContent, setBodyContent] = React.useState(
    "Once its gone, its gone!",
  );
  const [buttonActionContent, setButtonActionContent] =
    React.useState("Delete");

  const eventWorkFlow = stateWorkflow[event];

  const workflow = eventWorkFlow.blocks.find(
    (b) => b.id === stateWorkflow.activeWorkflowId,
  );

  const handleDeleteWorkflowStep = React.useCallback(
    (workflowId) => {
      deleteWorkflowStep(event, workflowId);
    },
    [deleteWorkflowStep, event],
  );

  const onDeleteEmail = React.useCallback(() => {
    hidePanelClick();
    handleDeleteWorkflowStep(stateWorkflow.activeWorkflowId);
  }, [hidePanelClick, stateWorkflow, handleDeleteWorkflowStep]);

  const onResetToDefault = React.useCallback(() => {
    hidePanelClick();
    resetDefault(event, stateWorkflow.activeWorkflowId);
  }, [event, hidePanelClick, stateWorkflow.activeWorkflowId, resetDefault]);

  const hideConfirmDialogClick = () => {
    setShowConfirmDialog(false);
  };

  const client = useSelector((state) => state.client.data);

  const canSave = Number(client?.isMassEmailEnabled) === 1;

  const handleSave = React.useCallback(() => {
    const values = Object.values(workflow);

    let isValid = true;

    if (
      values.some((val) => val === "" || (Array.isArray(val) && !val.length))
    ) {
      isValid = false;
    }

    canSaveWorkflow(event, workflow.id);

    if (isValid) {
      hidePanelClick();
      saveWorkflow(event);
    }
  }, [hidePanelClick, event, canSaveWorkflow, workflow, saveWorkflow]);

  const showConfirmDialogClick = React.useCallback(
    ({ body, header, buttonAction }) => {
      setHeaderContent(header);
      setBodyContent(body);
      setButtonActionContent(buttonAction);
      setShowConfirmDialog(true);
    },
    [],
  );

  const smartFields = communicationSmartFields[event];
  const smartFieldOptions = format(communicationSmartFields[event]);

  return (
    <div
      className={`pp_trigger_edit_email ${
        show ? "pp_trigger_edit_email-open" : "pp_trigger_edit_email-closed"
      }`}
      style={{ zIndex: 202 }}
    >
      {showConfirmDialog ? (
        <ConfirmDialog
          headerContent={headerContent}
          bodyContent={bodyContent}
          buttonActionContent={buttonActionContent}
          onHideAction={hideConfirmDialogClick}
          onDeleteEmail={onDeleteEmail}
          onResetToDefault={onResetToDefault}
        />
      ) : null}
      <div className="pp_trigger_edit_email_header">
        {show && workflow.type}
        <div>
          <div className="pp_trigger_edit_kebab_holder">
            <button
              className="pp_trigger_edit_kebab_holder_button"
              type="button"
              onClick={onKebabClick}
              onBlur={hideMenu}
            >
              <Kebabs className="pp_comms_kebab" />
            </button>
            {showContext ? (
              <ul className="pp_trigger_add_context_menu">
                {workflow.canDelete && (
                  <li
                    onMouseDown={() =>
                      showConfirmDialogClick({
                        body: "Once its gone, its gone!",
                        header: "Delete Email?",
                        buttonAction: "Delete",
                      })
                    }
                  >
                    Delete Email
                  </li>
                )}
                <li
                  onMouseDown={() =>
                    showConfirmDialogClick({
                      body: "Change this back to the default setting. This will remove all your changes.",
                      header: "Reset to Default?",
                      buttonAction: "Reset",
                    })
                  }
                >
                  Reset to Default
                </li>
              </ul>
            ) : null}
          </div>
          <button
            type="button"
            className="pp_trigger_box_edit pp_trigger_box_edit--cancel"
            onClick={hidePanelClick}
          >
            Cancel
          </button>
          <button
            disabled={canSave === false}
            onClick={handleSave}
            type="button"
            className="pp_trigger_box_edit"
          >
            Save
          </button>
        </div>
      </div>
      <div className="pp_trigger_edit_email_content">
        <div className="pp_trigger_tab_menu">
          <button
            type="button"
            className={`pp_trigger_tab_item ${
              showEdit ? "pp_trigger_tab_item--selected" : null
            }`}
            onClick={onEditClick}
          >
            Edit
          </button>
          <button
            type="button"
            className={`pp_trigger_tab_item ${
              showEdit ? null : "pp_trigger_tab_item--selected"
            }`}
            onClick={onPreviewClick}
          >
            Preview
          </button>
        </div>
        {showEdit ? (
          <EditTabTriggerEmail
            event={event}
            smartFields={smartFieldOptions}
            placeholder="Enter message"
          />
        ) : (
          <PreviewTabTriggerEmail event={event} smartFields={smartFields} />
        )}
      </div>
    </div>
  );
}

EditTriggerEmail.propTypes = {
  show: PropTypes.bool.isRequired,
  event: PropTypes.string.isRequired,
  hidePanelClick: PropTypes.func.isRequired,
  saveWorkflow: PropTypes.func.isRequired,
  canSaveWorkflow: PropTypes.func.isRequired,
  resetDefault: PropTypes.func.isRequired,
  stateWorkflow: PropTypes.object.isRequired,
  deleteWorkflowStep: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTriggerEmail);
